/* ==========================================================================
   Flow Check quiz — Nature's Pure Blend
   Drives the fc-* sections on the page:
     intro (Intro hero + Science) -> quiz (Questions) -> loading -> result
   All wording, questions, answers and result rules come from the sections'
   settings in the theme editor. No personal data is stored or sent anywhere.
   ========================================================================== */
(function () {
  'use strict';
  if (window.FlowCheck) return; // script is included by every section; run once

  var RING = 351.9; // 2πr for r = 56
  var CHECK = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12l5 5 9-10"/></svg>';

  var state = { screen: 'intro', step: 0, answers: {}, timer: null, pending: null };

  /* ----- helpers ----- */
  function all(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function one(sel, root) { return (root || document).querySelector(sel); }
  function screenEl(name) { return one('[data-fc-screen="' + name + '"]'); }
  function designMode() { return !!(window.Shopify && window.Shopify.designMode); }
  function stopTimer() { clearInterval(state.timer); clearTimeout(state.timer); state.timer = null; }
  function steps() { var q = screenEl('quiz'); return q ? all('[data-fc-step]', q) : []; }

  function scrollTop() {
    var first = all('.fc-sec--header')[0] || all('[data-fc-screen]:not([hidden])')[0];
    var top = first ? first.getBoundingClientRect().top + window.pageYOffset : 0;
    window.scrollTo(0, Math.max(0, top));
  }

  function show(name, opts) {
    opts = opts || {};
    if (name === 'intro' && !screenEl('intro')) name = 'quiz'; // no intro sections on the page
    state.screen = name;
    all('[data-fc-screen]').forEach(function (el) {
      el.hidden = el.getAttribute('data-fc-screen') !== name;
    });
    if (!opts.noScroll) scrollTop();
  }

  /* ----- quiz ----- */
  function questionsIn(step) { return all('[data-fc-question]', step); }

  function stepComplete(step) {
    return questionsIn(step).every(function (q) {
      return state.answers[q.getAttribute('data-fc-question')] != null || !one('.fc-opt', q);
    });
  }

  function renderStep(opts) {
    opts = opts || {};
    var quiz = screenEl('quiz');
    var list = steps();
    if (!quiz || !list.length) return;
    if (state.step > list.length - 1) state.step = list.length - 1;
    if (state.step < 0) state.step = 0;

    list.forEach(function (el, i) {
      el.hidden = i !== state.step;
      el.classList.toggle('is-multi', questionsIn(el).length > 1);
    });
    var cur = list[state.step];

    var label = (quiz.getAttribute('data-fc-progress') || 'Question {current} of {total}')
      .replace(/\{current\}/g, state.step + 1).replace(/\{total\}/g, list.length);
    var count = one('[data-fc-count]', quiz); if (count) count.textContent = label;
    var pct = Math.round(((state.step + 1) / list.length) * 100);
    var bar = one('[data-fc-bar]', quiz); if (bar) bar.style.width = pct + '%';
    var pb = one('[data-fc-progressbar]', quiz); if (pb) pb.setAttribute('aria-valuenow', pct);

    all('[data-fc-question]', quiz).forEach(function (q) {
      var chosen = state.answers[q.getAttribute('data-fc-question')];
      all('.fc-opt', q).forEach(function (o) {
        var on = chosen != null && o.getAttribute('data-value') === String(chosen);
        o.classList.toggle('is-selected', on);
        o.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    });

    var next = one('[data-fc-action="next"]', quiz);
    if (next) {
      var multi = cur.classList.contains('is-multi');
      next.hidden = !multi;
      next.disabled = !stepComplete(cur);
    }

    if (!opts.noFocus) {
      var f = one('[data-fc-focus]', cur);
      if (f) { try { f.focus({ preventScroll: true }); } catch (e) { f.focus(); } }
    }
  }

  function goToStep(i, opts) {
    stopTimer();
    state.step = i;
    show('quiz', opts);
    renderStep(opts);
  }

  function advance() {
    var list = steps();
    if (state.step < list.length - 1) goToStep(state.step + 1);
    else runLoading();
  }

  function pick(opt) {
    var q = opt.closest('[data-fc-question]');
    var step = opt.closest('[data-fc-step]');
    if (!q || !step || state.pending) return;
    state.answers[q.getAttribute('data-fc-question')] = opt.getAttribute('data-value');
    renderStep({ noFocus: true });
    if (!step.classList.contains('is-multi')) {
      state.pending = setTimeout(function () { state.pending = null; advance(); }, 120);
    }
  }

  /* ----- loading ----- */
  function runLoading() {
    var el = screenEl('loading');
    if (!el) { renderResult(profile()); return; }
    show('loading');
    var rows = all('[data-fc-lstep]', el);
    var duration = parseFloat(el.getAttribute('data-fc-duration')) || 4.5;
    var hold = Math.min(400, duration * 250);            // short pause at 100% before the results
    var run = Math.max(300, duration * 1000 - hold);     // total on screen ≈ the "Loading time" setting
    var ticks = 50, lp = 0;
    setLoading(el, rows, 0);
    stopTimer();
    state.timer = setInterval(function () {
      lp = Math.min(100, lp + 100 / ticks);
      setLoading(el, rows, lp);
      if (lp >= 100) { stopTimer(); state.timer = setTimeout(function () { renderResult(profile()); }, hold); }
    }, run / ticks);
  }

  function setLoading(el, rows, lp) {
    var pct = one('[data-fc-pct]', el); if (pct) pct.textContent = Math.round(lp);
    var ring = one('[data-fc-ring]', el); if (ring) ring.setAttribute('stroke-dashoffset', (RING * (1 - lp / 100)).toFixed(1));
    var n = rows.length;
    rows.forEach(function (r, k) {
      var start = (k * 100) / n, end = ((k + 1) * 100) / n;
      r.classList.toggle('is-done', lp >= end);
      r.classList.toggle('is-active', lp < end && lp >= start);
    });
  }

  /* ----- results ----- */
  function maxReasons() {
    var r = screenEl('result');
    return r ? parseInt(r.getAttribute('data-fc-max-reasons'), 10) || 3 : 3;
  }

  // Builds the result from the chosen answers' "Results effect" and "Results line".
  function profile() {
    var p = { level: 'good', strong: false, why: [] };
    var reasons = [], pinned = [];
    var POINTS = { low: 1, good: 2, strong: 3 }, total = 0, count = 0;
    all('[data-fc-question]').forEach(function (q) {
      var v = state.answers[q.getAttribute('data-fc-question')];
      if (v == null) return;
      var o = one('.fc-opt[data-value="' + v + '"]', q);
      if (!o) return;
      var eff = o.getAttribute('data-effect');
      if (POINTS[eff]) { total += POINTS[eff]; count++; }
      var line = o.getAttribute('data-reason');
      if (line) (q.getAttribute('data-fc-pin') === 'true' ? pinned : reasons).push(line);
    });
    p.why = reasons.slice(0, maxReasons()).concat(pinned);
    // Average of the answers that carry points: 2.5+ strong, 1.5–2.49 good, below 1.5 low.
    // No scored answers at all -> good.
    if (count) {
      var avg = total / count;
      p.level = avg >= 2.5 ? 'strong' : (avg >= 1.5 ? 'good' : 'low');
    }
    p.score = count ? total / count : null;
    p.strong = p.level === 'strong';
    return p;
  }

  // Editor preview: sample lines taken from the first answer of each question that has one.
  function previewProfile(kind) {
    var reasons = [], pinned = [];
    all('[data-fc-question]').forEach(function (q) {
      var o = all('.fc-opt', q).filter(function (x) { return x.getAttribute('data-reason'); })[0];
      if (o) (q.getAttribute('data-fc-pin') === 'true' ? pinned : reasons).push(o.getAttribute('data-reason'));
    });
    var level = kind === 'strong' ? 'strong' : (kind === 'low' ? 'low' : 'good');
    return { level: level, strong: level === 'strong', why: reasons.slice(0, maxReasons()).concat(pinned) };
  }

  function renderResult(p, opts) {
    stopTimer();
    var r = screenEl('result');
    if (!r) return;
    var attr = function (k) { return r.getAttribute('data-fc-' + k) || ''; };
    var match = p.level;

    var h = one('[data-fc-headline]', r); if (h) h.textContent = attr('headline-' + p.level) || attr('headline-good');
    var ml = one('[data-fc-match-label]', r); if (ml) ml.textContent = attr('label-' + p.level) || attr('label-good');
    var s2 = one('[data-fc-seg2]', r); if (s2) s2.classList.toggle('is-on', p.level !== 'low');
    var s3 = one('[data-fc-seg3]', r); if (s3) s3.classList.toggle('is-on', p.level === 'strong');
    r.setAttribute('data-fc-level', p.level);

    var ul = one('[data-fc-why]', r);
    if (ul) {
      ul.innerHTML = '';
      p.why.forEach(function (t) {
        var li = document.createElement('li');
        li.innerHTML = CHECK + '<span></span>';
        li.lastChild.textContent = t;
        ul.appendChild(li);
      });
      var block = one('[data-fc-why-block]', r); if (block) block.hidden = !p.why.length;
    }

    var cl = one('[data-fc-cta-label]', r); if (cl) cl.textContent = attr('cta-label');
    var cta = one('[data-fc-cta]', r);
    if (cta) {
      try {
        var url = new URL(attr('cta-url') || '/', window.location.href);
        if (attr('track') !== 'false') {
          url.searchParams.set('utm_source', 'flow_check');
          url.searchParams.set('fc_match', match);
        }
        cta.href = url.toString();
      } catch (e) { /* keep server-rendered href */ }
    }
    show('result', opts);
  }

  function previewResult() {
    var r = screenEl('result');
    renderResult(previewProfile(r ? r.getAttribute('data-fc-preview') : 'strong'), { noScroll: true });
  }

  function restart() {
    stopTimer();
    state.step = 0;
    state.answers = {};
    show('intro');
  }

  /* ----- events ----- */
  document.addEventListener('click', function (e) {
    var opt = e.target.closest('.fc-opt');
    if (opt && opt.closest('[data-fc-screen="quiz"]')) { pick(opt); return; }
    var el = e.target.closest('[data-fc-action]');
    if (!el || !el.closest('.fc')) return;
    var act = el.getAttribute('data-fc-action');
    if (act === 'start') { state.answers = {}; goToStep(0); }
    else if (act === 'back') { if (state.step > 0) goToStep(state.step - 1); else show('intro'); }
    else if (act === 'next') { var list = steps(); if (list[state.step] && stepComplete(list[state.step])) advance(); }
    else if (act === 'restart') { restart(); }
  });

  // Re-apply the current screen after the editor re-renders a section.
  function refresh() {
    if (state.screen === 'quiz') goToStep(state.step, { noScroll: true, noFocus: true });
    else if (state.screen === 'result') { if (designMode()) previewResult(); else renderResult(profile(), { noScroll: true }); }
    else if (state.screen === 'loading') { var el = screenEl('loading'); show('loading', { noScroll: true }); if (el) setLoading(el, all('[data-fc-lstep]', el), 60); }
    else show(state.screen, { noScroll: true });
  }

  // Theme editor: clicking a section or block shows the matching screen/step.
  function focusFromEditor(target) {
    var scr = target.closest ? target.closest('[data-fc-screen]') : null;
    if (!scr && !target.hasAttribute('data-shopify-editor-block')) { scr = target.querySelector ? target.querySelector('[data-fc-screen]') : null; }
    if (!scr) return;
    var name = scr.getAttribute('data-fc-screen');
    stopTimer();
    if (name === 'quiz') {
      var step = target.closest ? target.closest('[data-fc-step]') : null;
      if (!step) { var q = target.closest && target.closest('[data-fc-question]'); step = q ? q.closest('[data-fc-step]') : null; }
      var idx = step ? steps().indexOf(step) : state.step;
      goToStep(idx < 0 ? 0 : idx, { noScroll: true, noFocus: true });
    } else if (name === 'result') {
      previewResult();
    } else if (name === 'loading') {
      show('loading', { noScroll: true });
      setLoading(scr, all('[data-fc-lstep]', scr), 60);
    } else {
      show(name, { noScroll: true });
    }
  }

  // "Show in the editor preview" setting (single-section build).
  function editorScreen() {
    var el = one('[data-fc-editor-screen]');
    return el ? el.getAttribute('data-fc-editor-screen') : '';
  }
  function applyEditorScreen(name) {
    stopTimer();
    if (name === 'quiz') goToStep(0, { noScroll: true, noFocus: true });
    else if (name === 'result') previewResult();
    else if (name === 'loading') { var el = screenEl('loading'); show('loading', { noScroll: true }); if (el) setLoading(el, all('[data-fc-lstep]', el), 60); }
    else show('intro', { noScroll: true });
  }

  document.addEventListener('shopify:section:load', function (e) {
    var wanted = editorScreen();
    if (wanted && wanted !== state.editorScreen) { state.editorScreen = wanted; applyEditorScreen(wanted); }
    else refresh();
  });
  document.addEventListener('shopify:section:select', function (e) {
    if (editorScreen()) return; // single section: keep the current screen
    focusFromEditor(e.target);
  });
  document.addEventListener('shopify:block:select', function (e) { focusFromEditor(e.target); });

  function init() {
    state.editorScreen = editorScreen();
    if (designMode() && state.editorScreen) applyEditorScreen(state.editorScreen);
    else show('intro', { noScroll: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  window.FlowCheck = { refresh: refresh, profile: profile, state: state };
})();
